import { render, staticRenderFns } from "./MainBottom.vue?vue&type=template&id=55e58901&scoped=true"
import script from "./MainBottom.vue?vue&type=script&lang=js"
export * from "./MainBottom.vue?vue&type=script&lang=js"
import style0 from "./MainBottom.vue?vue&type=style&index=0&id=55e58901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e58901",
  null
  
)

export default component.exports